
import { computed, defineComponent, onMounted, ref } from "vue";
import moment from "moment";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import router from "@/router";
import { Paging, IrbChairFilter } from "@/store/modules/IrbApplicationModule";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import KtAssignIrbModal from "@/views/pages/chair/AssignIrbModal.vue";
import KtTransactionModal from "@/views/pages/chair/TransactionLogsModal.vue";
import KtMemberApprovalModal from "@/views/pages/member/StandardApplicationsApprovalModal.vue";
import AplicationTableAction from "@/components/table/ApplicationTableAction.vue";

export default defineComponent({
  name: "view-users",
  methods: {
    moment(date) {
      return moment(date).format("MMM DD YYYY");
    },
    resetSelected() {
      return this.selected = {value:"...", label:"..."};
    },

  },
  components: {
    KtAssignIrbModal,
    KtMemberApprovalModal,
    KtTransactionModal,
    AplicationTableAction,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const tableColumns = ["irbid", "researchtitle", "reviewtype", "piinfo", "requestedIrbMemberStatus",  "requestedIrbMembersAssignedDate", "reviewerEmail"];
    //const tableCallFunction = Actions.GET_IRBCHAIR_APPS;
    const tableCallFunction = Actions.GET_IRBCHAIR_APPS_EXPEDITED;



    const currentIrbchairApps = computed(() => {
      return store.getters.currentIrbchairApps?.data;
    });

    onMounted(() => {
      MenuComponent.reinitialization();
      setCurrentPageBreadcrumbs("View Users", ["Modals", "General"]);
    });

    const assign = (app, idx) => {
      store.commit(Mutations.SET_IRBCHAIR_APP, app);
    };

    const viewDetail = (request) => {
      router.push({ name: 'view-review', params: { id: request.irbApplicationId } });
    };

    const makeDecisionVote = (request) => {
      return store.commit(Mutations.SET_FACULTY_MEMBER_REQUEST_EDIT, request);;
    };

    const selected = {value: "...", label: "..."}; 
    const buttonActions = (request,idx) => {
      const buttons = [   
        {value: "View Application", label: "View", action: () => viewDetail(request),
        toggle:"#", target: "#", rq: null},
        {value: "Transaction Log", label: "Transaction Log", action: () => assign(request, idx),
        toggle:"modal", target: "#kt_modal_transaction_modal", rq: null}
      ];
      if (request.irbStatus == 'Pending' ||
          request.irbStatus == 'Under Review' ) {
            if (request.appStatus != "Voting") {
              buttons.push({value: "Assign", label: "Assign", action: () => assign(request, idx), 
              toggle:"modal", target: "#kt_modal_assign_irb", rq: request});
            }
        }
        if (request.appStatus == "Voting") {
          buttons.push({value: "Vote on Application", label: "Vote", action: () => makeDecisionVote(request),
          toggle:"modal", target: "#kt_modal_user_approve_vote", rq: request}); 
        }

      return buttons;
    } 
    
    return {
      currentIrbchairApps,
      assign,
      selected,
      buttonActions,
      viewDetail,
      tableColumns,
      tableCallFunction,
    };
  },
});
